import { FrameworkConfiguration, Container } from 'aurelia-framework';
import { I18N, Backend, TCustomAttribute } from 'aurelia-i18n';

export function configure(config: FrameworkConfiguration): void {
  var i18n = Container.instance.get(I18N);
  i18n.i18next.loadNamespaces(["Core.Activate", "Core.AuditLog", "Core.ChangePassword", "Core.CreatePassword",
    "Core.ForgetPassword", "Core.ManageConfiguration", "Core.ManageUser", "Core.ManageUserGroup",
    "Core.UserDetail", "Core.UserGroupDetail"
  ]).then(() => {
    console.log("Load namespace Core succeed.");
  }).catch((reason) => {
    console.log("Load namespace Core failed. reason: " + reason)
  });
  //config.globalResources([]);
}
